<template>
  <div class="page flex-col">
    <div class="main1 flex-col">
      <img
        class="img1"
        referrerpolicy="no-referrer"
        src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngad5f0d35d719a5e8e532d9026a1423ccdd763d660c0787a153fa85932c23e026"
      />
    </div>
    <div class="main2 flex-col"></div>
    <span class="word3">字</span>
    <div class="main3 flex-col"></div>
    <div class="main4 flex-col"></div>
    <div class="main5 flex-col"></div>
    <div class="main6 flex-col">
      <div class="section5 flex-col">
        <div class="group1 flex-col justify-center">
          <span class="txt3">简单检索</span>
        </div>
        <span class="word4">词性统计</span> <span class="word5">词频分布</span>
        <span class="txt4">历时分析</span> <span class="info5">共现检索</span>
        <div class="group2 flex-row justify-between">
          <span class="word6">对比检索</span>
          <img
            class="label1"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng05a22cb39a151459a8bed0ab90f14b68c155c7276153469cb5b956b09e0be4b3"
          />
        </div>
      </div>
    </div>
    <div class="main7 flex-col"></div>
    <div class="main8 flex-col">
      <div class="group3 flex-col">
        <div class="group4 flex-row">
          <span class="info6">搜索词汇：</span>
          <div class="box1 flex-col justify-center">
            <span class="word7">请输入关键词</span>
          </div>
          <div class="box2 flex-col justify-center">
            <span class="info7">请输入关键词</span>
          </div>
        </div>
        <div class="group5 flex-row">
          <span class="txt5">选择分类：</span>
          <div class="layer1 flex-col justify-center">
            <div class="outer1 flex-row justify-between">
              <span class="word8">集部</span>
              <img
                class="label2"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng7637afd53adc8abc35cb2eae3e9d3d633ec7da637c4ee6b035cd99e63ec09c90"
              />
            </div>
          </div>
          <div class="layer2 flex-col justify-center align-center">
            <div class="bd1 flex-row justify-between">
              <span class="word9">语言文学类</span>
              <img
                class="label3"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng7637afd53adc8abc35cb2eae3e9d3d633ec7da637c4ee6b035cd99e63ec09c90"
              />
            </div>
          </div>
          <div class="layer3 flex-col justify-center align-center">
            <div class="section6 flex-row justify-between">
              <span class="word10">元</span>
              <img
                class="icon1"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng7637afd53adc8abc35cb2eae3e9d3d633ec7da637c4ee6b035cd99e63ec09c90"
              />
            </div>
          </div>
          <span class="word11">相距不超过：</span>
          <div class="layer4 flex-col justify-center align-center">
            <div class="layer5 flex-row justify-between">
              <span class="word12">100</span>
              <img
                class="icon2"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng7637afd53adc8abc35cb2eae3e9d3d633ec7da637c4ee6b035cd99e63ec09c90"
              />
            </div>
          </div>
        </div>
        <div class="group6 flex-row">
          <span class="info8">匹配模式：</span>
          <div class="box3 flex-col"></div>
          <span class="word13">完全匹配</span>
          <div class="box4 flex-col"></div>
          <span class="info9">匹配词头</span>
          <div class="box5 flex-col"></div>
          <span class="word14">匹配词属</span>
        </div>
        <button
          class="group7 flex-col justify-center align-center"
          @click="onClick_1"
        >
          <span class="word15">搜索</span>
        </button>
        <div class="group8 flex-col">
          <div class="outer2 flex-row">
            <div class="section7">
              <span class="word16"
                >搜索：“云”&nbsp;共有&nbsp;277&nbsp;&nbsp;条结果，&nbsp;每页显示&nbsp;10&nbsp;</span
              >
              <span class="word17">40</span>
              <span class="txt6">&nbsp;&nbsp;100&nbsp;条</span>
            </div>
            <img
              class="label4"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngd927188d3cfeead100d73200dcfd4519628c417d7139cec797c00a7d53c96d10"
            />
            <span class="txt7">下载</span>
            <img
              class="icon3"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngabbacc7ed77276b2ffbb06e7d1a7490690b1ffff6f03a57893223cee03921e8e"
            />
            <span class="word18">收藏</span>
          </div>
        </div>
        <div class="group9 flex-row justify-between">
          <div class="layer6">
            <span class="info10"
              >..老丞相再饮一杯。(正末做醉科)(李圭云)我也吃一杯。</span
            >
            <span class="word19">云</span>
            <span class="word20"
              >今日吃酒已散。圣人的命，教您这管军元帅...饮一杯。(正末做醉科)(李圭云)我也吃一杯</span
            >
          </div>
          <span class="info11">查看原文</span>
        </div>
        <div class="group10 flex-row justify-between">
          <div class="main9">
            <span class="word21"
              >..老丞相再饮一杯。(正末做醉科)(李圭云)我也吃一杯。</span
            >
            <span class="txt8">云</span>
            <span class="word22"
              >今日吃酒已散。圣人的命，教您这管军元帅...饮一杯。(正末做醉科)(李圭云)我也吃一杯</span
            >
          </div>
          <span class="word23">查看原文</span>
        </div>
        <div class="group11 flex-row justify-between">
          <div class="bd2">
            <span class="info12"
              >..老丞相再饮一杯。(正末做醉科)(李圭云)我也吃一杯。</span
            >
            <span class="txt9">云</span>
            <span class="info13"
              >今日吃酒已散。圣人的命，教您这管军元帅...饮一杯。(正末做醉科)(李圭云)我也吃一杯</span
            >
          </div>
          <span class="txt10">查看原文</span>
        </div>
        <div class="group12 flex-row justify-between">
          <div class="main10">
            <span class="word24"
              >..老丞相再饮一杯。(正末做醉科)(李圭云)我也吃一杯。</span
            >
            <span class="txt11">云</span>
            <span class="info14"
              >今日吃酒已散。圣人的命，教您这管军元帅...饮一杯。(正末做醉科)(李圭云)我也吃一杯</span
            >
          </div>
          <span class="word25">查看原文</span>
        </div>
        <div class="group13 flex-row justify-between">
          <div class="box6">
            <span class="word26"
              >..老丞相再饮一杯。(正末做醉科)(李圭云)我也吃一杯。</span
            >
            <span class="word27">云</span>
            <span class="word28"
              >今日吃酒已散。圣人的命，教您这管军元帅...饮一杯。(正末做醉科)(李圭云)我也吃一杯</span
            >
          </div>
          <span class="info15">查看原文</span>
        </div>
        <div class="group14 flex-row justify-between">
          <div class="outer3">
            <span class="txt12"
              >..老丞相再饮一杯。(正末做醉科)(李圭云)我也吃一杯。</span
            >
            <span class="word29">云</span>
            <span class="word30"
              >今日吃酒已散。圣人的命，教您这管军元帅...饮一杯。(正末做醉科)(李圭云)我也吃一杯</span
            >
          </div>
          <span class="txt13">查看原文</span>
        </div>
        <div class="group15 flex-row justify-between">
          <div class="main11">
            <span class="info16"
              >..老丞相再饮一杯。(正末做醉科)(李圭云)我也吃一杯。</span
            >
            <span class="word31">云</span>
            <span class="txt14"
              >今日吃酒已散。教您这管军元帅...饮一杯。(正末做醉科)(李圭云)我也吃一杯</span
            >
          </div>
          <span class="word32">查看原文</span>
        </div>
        <div class="group16 flex-row justify-between">
          <div class="block1">
            <span class="info17"
              >..老丞相再饮一杯。(正末做醉科)(李圭云)我也吃一杯。</span
            >
            <span class="txt15">云</span>
            <span class="word33"
              >今日吃3333。圣人的命，教您这管军元帅...饮一杯。(正末做醉科)(李圭云)我也吃一杯</span
            >
          </div>
          <span class="txt16">查看原文</span>
        </div>
        <div class="group17 flex-row">
          <img
            class="icon4"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngd3aa89473707ea1e056d7e1aa72bce78f542ddfb9e201b797b82a48f29af60e9"
          />
          <div class="section8 flex-col justify-center align-center">
            <span class="word34">1</span>
          </div>
          <span class="word35">2</span> <span class="info18">3</span>
          <span class="info19">4</span> <span class="info20">5</span>
          <img
            class="label5"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng5a171251fcdf4cf488d13c99c9531cdc9b93293b75aaee59b61200d339e396fa"
          />
        </div>
      </div>
    </div>
    <div class="main12 flex-col">
      <div class="section9 flex-col justify-between">
        <span class="word36">词性统计</span>
        <span class="txt17">词频分布</span> <span class="info21">历史分析</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      constants: {},
    }
  },
  methods: {
    onClick_1 () {
      alert(1)
    },
  },
};
</script>
<style scoped>
html {
  font-size: 37.5px;
}

.page {
  position: relative;
  width: 38.4rem;
  height: 26.08rem;
  background-color: rgba(245, 245, 245, 1);
  overflow: hidden;
  margin: 0 auto;
}

.main1 {
  width: 38.4rem;
  height: 26.08rem;
}

.section1 {
  height: 2.08rem;
  background-color: rgba(255, 255, 255, 1);
  width: 38.4rem;
  padding: 0.507rem 0 0 2.987rem;
}

.section2 {
  width: 32.214rem;
  height: 1.307rem;
}

.mod1 {
  width: 4.534rem;
  height: 1.307rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng4763fecae4f3dbd33fedecbd4a2e0fc03f75b4cd8e9d4e000fe793b5c88589d4)
    0.187rem 0rem no-repeat;
  background-size: 4.347rem 1.334rem;
}

.info1 {
  width: 0.88rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 4.08rem;
}

.txt1 {
  width: 1.734rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.547rem;
}

.info2 {
  width: 1.734rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.52rem;
}

.mod2 {
  height: 0.827rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngde1affade5c2e666edec9c444d5aefef0a47db75485b18d5ca2e15fd7018c5d9)
    0rem 0rem no-repeat;
  background-size: 3.467rem 0.827rem;
  padding-top: 0.16rem;
  width: 3.467rem;
  margin: 0.134rem 0 0 0.56rem;
}

.word1 {
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.info3 {
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.707rem;
}

.mod3 {
  width: 0.427rem;
  height: 0.587rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng5618ba96d6e45c5af5d14cae1dcfca8615fc726c6816559d10f2f2d325c1d304)
    100% no-repeat;
  margin: 0.24rem 0 0 6.214rem;
}

.word2 {
  width: 0.747rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 0.214rem;
}

.mod4 {
  width: 0.027rem;
  height: 0.427rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng292e16e315659a9700abfa430c040d1419bc4573dc009e320d08121fccd7eb1f)
    0rem 0rem no-repeat;
  background-size: 0.027rem 0.454rem;
  margin: 0.347rem 0 0 0.294rem;
}

.txt2 {
  width: 0.747rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 0.294rem;
}

.img1 {
  width: 38.4rem;
  height: 11.44rem;
  margin-top: 10.427rem;
}

.section3 {
  width: 38.4rem;
  height: 0.134rem;
  background-color: rgba(170, 29, 31, 1);
}

.section4 {
  z-index: 26;
  height: 2rem;
  overflow: hidden;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng2dc70e2dd957c588ff9bfdb344f8935d1e22f4b76f2bdd7091a344d1f294119c)
    100% no-repeat;
  width: 38.4rem;
  position: relative;
  padding: 0.747rem 0 0 16.187rem;
}

.info4 {
  z-index: 29;
  position: static;
  left: 16.187rem;
  top: 24.827rem;
  width: 6.054rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.373rem;
  font-family: PingFangTC-Regular;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.img2 {
  z-index: 27;
  position: absolute;
  left: 0;
  top: 0;
  width: 38.4rem;
  height: 2rem;
}

.main2 {
  z-index: 35;
  position: absolute;
  left: 3.227rem;
  top: 4.454rem;
  width: 6.134rem;
  height: 0.027rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng1ab15bd4dc6a791a2cb4428f49a8875cd906aaad12f9ea1f6719ed5042972104) -0.027rem
    0rem no-repeat;
  background-size: 6.187rem 0.027rem;
}

.word3 {
  z-index: 131;
  position: absolute;
  left: 38.374rem;
  top: 5.574rem;
  width: 0.374rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.85);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
}

.main3 {
  z-index: 36;
  position: absolute;
  left: 3.227rem;
  top: 5.92rem;
  width: 6.134rem;
  height: 0.027rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngaa34d315103c42faff9e2ec05e7a8d7a1c85b5f4625feb0ad76e3a9a9105f32f) -0.027rem
    0rem no-repeat;
  background-size: 6.187rem 0.027rem;
}

.main4 {
  z-index: 37;
  position: absolute;
  left: 3.227rem;
  top: 7.387rem;
  width: 6.134rem;
  height: 0.027rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng1ab15bd4dc6a791a2cb4428f49a8875cd906aaad12f9ea1f6719ed5042972104) -0.027rem
    0rem no-repeat;
  background-size: 6.187rem 0.027rem;
}

.main5 {
  z-index: 38;
  position: absolute;
  left: 3.227rem;
  top: 8.854rem;
  width: 6.134rem;
  height: 0.027rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng1ab15bd4dc6a791a2cb4428f49a8875cd906aaad12f9ea1f6719ed5042972104) -0.027rem
    0rem no-repeat;
  background-size: 6.187rem 0.027rem;
}

.main6 {
  z-index: 32;
  height: 12.24rem;
  border-radius: 4px;
  border: 1px solid rgba(229, 229, 229, 1);
  background-color: rgba(255, 255, 255, 1);
  width: 6.134rem;
  position: absolute;
  left: 3.2rem;
  top: 1.014rem;
}

.section5 {
  width: 6.134rem;
  height: 8.24rem;
}

.group1 {
  height: 1.44rem;
  border-radius: 4px 4px 0 0;
  background-color: rgba(170, 29, 31, 0.16);
  padding-left: 2.267rem;
  width: 6.134rem;
}

.txt3 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Semibold;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
}

.word4 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin: 0.56rem 0 0 2.267rem;
}

.word5 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin: 1.094rem 0 0 2.267rem;
}

.txt4 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin: 1.094rem 0 0 2.267rem;
}

.info5 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin: 1.094rem 0 0 2.267rem;
}

.group2 {
  width: 2.187rem;
  height: 0.374rem;
  margin: 1.094rem 0 0 2.267rem;
}

.word6 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
}

.label1 {
  width: 0.187rem;
  height: 0.134rem;
  margin-top: 0.134rem;
}

.main7 {
  z-index: 39;
  position: absolute;
  left: 3.227rem;
  top: 10.32rem;
  width: 6.134rem;
  height: 0.027rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng1ab15bd4dc6a791a2cb4428f49a8875cd906aaad12f9ea1f6719ed5042972104) -0.027rem
    0rem no-repeat;
  background-size: 6.187rem 0.027rem;
}

.main8 {
  z-index: 51;
  height: 19.014rem;
  border-radius: 4px;
  border: 1px solid rgba(229, 229, 229, 1);
  background-color: rgba(255, 255, 255, 1);
  width: 25.307rem;
  position: absolute;
  left: 9.894rem;
  top: 1.014rem;
  padding: 0.72rem 0 0 0.774rem;
}

.group3 {
  width: 23.867rem;
  height: 17.494rem;
}

.group4 {
  width: 18.934rem;
  height: 0.96rem;
  margin-left: 0.134rem;
}

.info6 {
  width: 1.867rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.85);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
  margin-top: 0.187rem;
}

.box1 {
  height: 0.96rem;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background-color: rgba(255, 255, 255, 1);
  padding-left: 0.294rem;
  width: 8.374rem;
}

.word7 {
  width: 2.24rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
}

.box2 {
  height: 0.96rem;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background-color: rgba(255, 255, 255, 1);
  margin-left: 0.32rem;
  padding-left: 0.294rem;
  width: 8.374rem;
}

.info7 {
  width: 2.24rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
}

.group5 {
  width: 23.547rem;
  height: 0.987rem;
  margin-top: 0.64rem;
}

.txt5 {
  width: 1.867rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.85);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
  margin-top: 0.187rem;
}

.layer1 {
  height: 0.96rem;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background-color: rgba(255, 255, 255, 1);
  padding-left: 0.294rem;
  width: 4.214rem;
}

.outer1 {
  width: 3.6rem;
  height: 0.587rem;
}

.word8 {
  width: 1.974rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
}

.label2 {
  width: 0.267rem;
  height: 0.187rem;
  margin-top: 0.214rem;
}

.layer2 {
  height: 0.96rem;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background-color: rgba(255, 255, 255, 1);
  margin-left: 0.32rem;
  width: 5.44rem;
}

.bd1 {
  width: 4.8rem;
  height: 0.587rem;
}

.word9 {
  width: 1.974rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
}

.label3 {
  width: 0.267rem;
  height: 0.187rem;
  margin-top: 0.214rem;
}

.layer3 {
  height: 0.96rem;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background-color: rgba(255, 255, 255, 1);
  margin-left: 0.32rem;
  width: 5.44rem;
}

.section6 {
  width: 4.8rem;
  height: 0.587rem;
}

.word10 {
  width: 1.974rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
}

.icon1 {
  width: 0.267rem;
  height: 0.187rem;
  margin-top: 0.214rem;
}

.word11 {
  width: 2.24rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.85);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
  margin: 0.214rem 0 0 0.32rem;
}

.layer4 {
  height: 0.96rem;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background-color: rgba(255, 255, 255, 1);
  width: 3.067rem;
  margin: 0.027rem 0 0 0.32rem;
}

.layer5 {
  width: 2.427rem;
  height: 0.587rem;
}

.word12 {
  width: 1.974rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
}

.icon2 {
  width: 0.267rem;
  height: 0.187rem;
  margin-top: 0.214rem;
}

.group6 {
  width: 11.334rem;
  height: 0.587rem;
  margin-top: 0.614rem;
}

.info8 {
  width: 1.867rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.85);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
}

.box3 {
  width: 0.427rem;
  height: 0.427rem;
  border-radius: 1px;
  border: 1px solid rgba(191, 191, 191, 1);
  margin: 0.08rem 0 0 0.187rem;
}

.word13 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin: 0.107rem 0 0 0.32rem;
}

.box4 {
  width: 0.427rem;
  height: 0.427rem;
  border-radius: 1px;
  border: 1px solid rgba(191, 191, 191, 1);
  margin: 0.08rem 0 0 1.28rem;
}

.info9 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin: 0.107rem 0 0 0.32rem;
}

.box5 {
  width: 0.427rem;
  height: 0.427rem;
  border-radius: 1px;
  border: 1px solid rgba(191, 191, 191, 1);
  margin: 0.08rem 0 0 1.28rem;
}

.word14 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin: 0.107rem 0 0 0.32rem;
}

.group7 {
  height: 0.854rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng5e9b1c46da2160fb484aad89ac9fd283325c80ffa4adb2bcf58d0a8b98424728)
    100% no-repeat;
  margin-top: 0.694rem;
  width: 1.814rem;
}

.word15 {
  width: 0.747rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
}

.group8 {
  height: 1.094rem;
  border-radius: 2px;
  background-color: rgba(242, 242, 242, 1);
  margin-top: 0.694rem;
  width: 23.867rem;
  padding: 0.294rem 0 0 0.427rem;
}

.outer2 {
  width: 22.854rem;
  height: 0.534rem;
}

.section7 {
  width: 9.44rem;
  height: 0.374rem;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  margin-top: 0.08rem;
  font-size: 0;
}

.word16 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word17 {
  font-size: 0.373rem;
  color: rgba(170, 29, 31, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.txt6 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.label4 {
  width: 0.534rem;
  height: 0.534rem;
  margin-left: 10.347rem;
}

.txt7 {
  width: 0.747rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin: 0.08rem 0 0 0.08rem;
}

.icon3 {
  width: 0.534rem;
  height: 0.534rem;
  margin-left: 0.347rem;
}

.word18 {
  width: 0.747rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin: 0.08rem 0 0 0.08rem;
}

.group9 {
  width: 23.867rem;
  height: 0.587rem;
  margin-top: 0.747rem;
}

.layer6 {
  width: 12.16rem;
  height: 0.587rem;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  font-size: 0;
}

.info10 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word19 {
  font-size: 0.373rem;
  color: rgba(255, 128, 0, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word20 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info11 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin-top: 0.134rem;
}

.group10 {
  width: 23.867rem;
  height: 0.587rem;
  margin-top: 0.48rem;
}

.main9 {
  width: 17.04rem;
  height: 0.587rem;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  font-size: 0;
}

.word21 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.txt8 {
  font-size: 0.373rem;
  color: rgba(255, 128, 0, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word22 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word23 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin-top: 0.134rem;
}

.group11 {
  width: 23.867rem;
  height: 0.587rem;
  margin-top: 0.48rem;
}

.bd2 {
  width: 20.48rem;
  height: 0.587rem;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  font-size: 0;
}

.info12 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.txt9 {
  font-size: 0.373rem;
  color: rgba(255, 128, 0, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info13 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.txt10 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin-top: 0.134rem;
}

.group12 {
  width: 23.867rem;
  height: 0.587rem;
  margin-top: 0.48rem;
}

.main10 {
  width: 16.214rem;
  height: 0.587rem;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  font-size: 0;
}

.word24 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.txt11 {
  font-size: 0.373rem;
  color: rgba(255, 128, 0, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info14 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word25 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin-top: 0.134rem;
}

.group13 {
  width: 23.867rem;
  height: 0.587rem;
  margin-top: 0.48rem;
}

.box6 {
  width: 16.827rem;
  height: 0.587rem;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  font-size: 0;
}

.word26 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word27 {
  font-size: 0.373rem;
  color: rgba(255, 128, 0, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word28 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info15 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin-top: 0.134rem;
}

.group14 {
  width: 23.867rem;
  height: 0.587rem;
  margin-top: 0.48rem;
}

.outer3 {
  width: 21.734rem;
  height: 0.587rem;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  font-size: 0;
}

.txt12 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word29 {
  font-size: 0.373rem;
  color: rgba(255, 128, 0, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word30 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.txt13 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin-top: 0.134rem;
}

.group15 {
  width: 23.867rem;
  height: 0.587rem;
  margin-top: 0.48rem;
}

.main11 {
  width: 18.347rem;
  height: 0.587rem;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  font-size: 0;
}

.info16 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word31 {
  font-size: 0.373rem;
  color: rgba(255, 128, 0, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.txt14 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word32 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin-top: 0.134rem;
}

.group16 {
  width: 23.867rem;
  height: 0.587rem;
  margin-top: 0.48rem;
}

.block1 {
  width: 12.16rem;
  height: 0.587rem;
  overflow-wrap: break-word;
  text-align: left;
  white-space: nowrap;
  font-size: 0;
}

.info17 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.txt15 {
  font-size: 0.373rem;
  color: rgba(255, 128, 0, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word33 {
  font-size: 0.373rem;
  color: rgba(51, 51, 51, 1);
  line-height: 0.374rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.txt16 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin-top: 0.134rem;
}

.group17 {
  width: 4.16rem;
  height: 0.64rem;
  margin: 0.934rem 0 0 19.654rem;
}

.icon4 {
  width: 0.32rem;
  height: 0.32rem;
  margin-top: 0.16rem;
}

.section8 {
  height: 0.64rem;
  border-radius: 2.181818181818182px 2.181818181818182px 2.181818181818182px
    2.181818181818182px;
  border: 1px solid rgba(170, 29, 31, 1);
  background-color: rgba(255, 255, 255, 1);
  margin-left: 0.16rem;
  width: 0.64rem;
}

.word34 {
  width: 0.16rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
}

.word35 {
  width: 0.24rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.65);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
  margin: 0.027rem 0 0 0.214rem;
}

.info18 {
  width: 0.24rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.65);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
  margin: 0.027rem 0 0 0.4rem;
}

.info19 {
  width: 0.24rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.65);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
  margin: 0.027rem 0 0 0.4rem;
}

.info20 {
  width: 0.24rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.65);
  font-size: 0.373rem;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
  margin: 0.027rem 0 0 0.4rem;
}

.label5 {
  width: 0.32rem;
  height: 0.32rem;
  margin: 0.16rem 0 0 0.347rem;
}

.main12 {
  z-index: 40;
  height: 3.44rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPnge1b2285b812d789dccfd4c2f000bb097617b6fc95b5e52b1dfbfe00a2efaebed)
    100% no-repeat;
  width: 6.134rem;
  position: absolute;
  left: 3.227rem;
  top: 11.787rem;
  padding: 0.534rem 0 0 2.24rem;
}

.section9 {
  width: 1.494rem;
  height: 2.4rem;
}

.word36 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
}

.txt17 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin-top: 0.64rem;
}

.info21 {
  width: 1.494rem;
  height: 0.374rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.374rem;
  text-align: left;
  margin-top: 0.64rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/analysis.vue